<template>
  <div class="container-action-history flex items-center">
    <v-popover
      trigger="hover"
      placement="bottom"
    >
      <div
        class="action-history-item"
        :class="{'disable' :disableUndoItem}"
        @click="undo()"
      >
        <svg
          :class="{'disable' :disableUndoItem}"
          class="action-history undo-action-history"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          name="undo"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.54232 5.59031C1.34462 5.39464 1.34462 5.07524 1.54232 4.87957L4.06976 2.37805C4.38548
            2.06557 4.92149 2.28921 4.92149 2.73342V4.52291H10.0838C12.2466 4.52291 14 6.27627
             14 8.43914C14 10.602 12.2466 12.3554 10.0838 12.3554H6.87958C6.48633 12.3554 6.16754
             12.0366 6.16754 11.6433C6.16754 11.2501 6.48633 10.9313 6.87958 10.9313H10.0838C11.4601
             10.9313 12.5759 9.81551 12.5759 8.43914C12.5759 7.06276 11.4601 5.94699 10.0838
             5.94699H4.92149V7.73645C4.92149
             8.18067 4.38548 8.40431 4.06976 8.09183L1.54232 5.59031Z"
            fill="#282E3E"
          />
        </svg>
      </div>
      <template slot="popover">
        <TooltipHistory action="undo" />
      </template>
    </v-popover>
    <v-popover
      trigger="hover"
      placement="bottom"
    >
      <div
        class="action-history-item"
        :class="{'disable' : disableRedoItem}"
        @click="redo()"
      >
        <svg
          :class="{'disable' : disableRedoItem}"
          class="action-history redo-action-history"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.4577 5.59031C14.6554 5.39464 14.6554 5.07524 14.4577
            4.87957L11.9302 2.37805C11.6145 2.06557 11.0785 2.28921 11.0785
            2.73342V4.52291H5.91623C3.75336 4.52291 2 6.27627 2 8.43914C2
            10.602 3.75336 12.3554 5.91623 12.3554H9.12042C9.51367 12.3554
            9.83246 12.0366 9.83246 11.6433C9.83246 11.2501 9.51367 10.9313
            9.12042 10.9313H5.91623C4.53986 10.9313 3.42408 9.81551 3.42408
            8.43914C3.42408 7.06276 4.53986 5.94699 5.91623 5.94699H11.0785V7.73645C11.0785
            8.18067 11.6145 8.40431 11.9302 8.09183L14.4577 5.59031Z"
            fill="#282E3E"
          />
        </svg>
      </div>
      <template slot="popover">
        <TooltipHistory action="redo" />
      </template>
    </v-popover>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TooltipHistory from './TooltipHistory'

export default {
  name: 'ControlActionHistoriesV2',
  components: {
    TooltipHistory,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState([
      'isBlockHistory',
      'isSyncing',
      'isDisableEditPresentation',
      'canEditPresentation',
    ]),
    // simplifiedSlides() {
    //   const { slides } = this.$store.state.presentation
    //   return ObjectService.prune(slides, TRACKED_ATTRIBUTES_SLIDES)
    // },
    disableUndoItem() {
      return !this.$store.getters['history/canBackward'] || this.isBlockHistory || this.isSyncing !== 2 || !this.canEditPresentation
    },
    disableRedoItem() {
      return !this.$store.getters['history/canForward'] || this.isBlockHistory || this.isSyncing !== 2 || !this.canEditPresentation
    },
    slides() {
      return this.$store.state.presentation.slides
    },
    slideActive() {
      return this.$store.state.slideActive
    },
  },
  mounted() {
    this.clearHistoryAction()
    this.takeSnapshot()
  },
  destroyed() {
    this.$store.dispatch('history/clearHistoryAction')
  },
  methods: {
    ...mapActions('history', ['clearHistoryAction']),
    takeSnapshot() {
      this.$store.dispatch('history/snapshotSlidesAction', { slideId: this.slideActive?.id, slides: this.slides })
    },
    undo() {
      if (this.disableUndoItem) return
      this.$store.dispatch('history/undoSlidesAction')
    },
    redo() {
      if (this.disableRedoItem) return
      this.$store.dispatch('history/redoSlidesAction')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.container-action-history {
  background: #ffffff;
  padding-top:7px;
  align-content: center;
  border: #00aced;
  border-radius: 3px;
  .action-history-item {
    padding : 4px;
    &:hover {
      &:not(.disable) {
        path{
          fill: $primary-color
        }
        cursor: pointer;
        background: #EFF1F7;
        border-radius: 3px;
      }

      .disable {
        cursor: no-drop;
      }
    }

    &:first-child {
      margin-right: 4px;
    }

    .action-history {
      color: #191F2D;

      &.disable {
        opacity: 0.3;
      }
    }
  }
}
</style>
